import { useState, useEffect, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from './Layout';

export default function AdminRoute({ Page }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    fetch('/api/user/me', { credentials: 'include' })
      .then(r => (r.ok ? r.json() : null))
      .then(user => setStatus(user?.isAdmin ? 'admin' : 'denied'))
      .catch(() => setStatus('denied'));
  }, []);

  if (status === 'loading') return null;
  if (status === 'denied') return <Navigate to="/" replace />;

  return (
    <Layout showFooter={false}>
      <Suspense fallback={null}>
        <Page />
      </Suspense>
    </Layout>
  );
}
